module.exports = __webpack_public_path__ + "img/gnb_logo_kr.05fd2ba.svg";